/*
Выводит секцию в карточке
Принимает массив элементов:
{
  text: string;
  value?: string;
  link?: string;
  isTitle?: boolean;
}[]
 */

export default {
  name: 'ActivePointSectionComponent',
  props: ['lines'],
  template: `
    <div v-if="lines && lines?.length" class="partners-map-point__section">
      <template v-for="line in lines">
        <div v-if="line?.isTitle" class="partners-map-point__section-title">
          {{line?.text}}
        </div>
        <div v-else class="partners-map-point__section-line">
          <div class="partners-map-point__section-line-title">
            {{line?.text}}
          </div>
          <div v-if="line?.value" class="partners-map-point__section-line-value">
            <a v-if="line?.link" :href="line.link" target="_blank">{{line.value}}</a>
            <span v-else>{{line.value}}</span>
          </div>
        </div>
      </template>
    </div>
  `,
}
